/* eslint-disable react/require-default-props */
/* eslint-disable react/no-array-index-key */

import { useTranslation } from 'providers/GILT.provider';

import ReportTableContainer from 'reports/Common/ReportTable';
import { calculateWorkingHoursByCategory, calculateWorkingHoursByService, convertHoursByCategoryOrServiceDataToTable } from 'reports/utils';

export const SalonHoursWorkedByCategoryOrServiceTable = ({ type, data, startDate, endDate }) => {
  const { t } = useTranslation();

  let tableData;
  if (type === 'Category') {
    tableData = {
      rows: convertHoursByCategoryOrServiceDataToTable(calculateWorkingHoursByCategory(data), type),
    };
  } else {
    tableData = {
      rows: convertHoursByCategoryOrServiceDataToTable(calculateWorkingHoursByService(data), type),
    };
  }

  return (
    <div id="salon-hours-worked-by-type">
      <ReportTableContainer startDate={startDate} endDate={endDate} title={t('businessReports.hours.hoursWorkedBy', { type })} data={tableData} />
      <br /> <br /> <br />
    </div>
  );
};
